<div *ngIf="cluster">
  <div id="cluster-general-information">
    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Name:</span>
      <span class="map-summary-item-value" [title]="cluster.name">{{cluster.name}}</span>
    </div>

    <div class="map-summary-item-container" *ngIf="cluster.nodes">
      <span class="map-summary-item-field">Number of voip peers:</span>
      <span class="map-summary-item-value" [title]="cluster.nodes.length">{{cluster.nodes.length}}</span>
    </div>

    <divider [title]="'VoIP Peers'"></divider>

    <div *ngFor="let voipPeerShape of cluster.nodes">
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Name:</span>
        <span class="map-summary-item-value" [title]="voipPeerShape.dataItem.name">{{voipPeerShape.dataItem.name}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Type:</span>
        <span class="map-summary-item-value" [title]="voipPeerShape.dataItem.deviceType">{{voipPeerShape.dataItem.deviceType}}</span>
      </div>
    </div>
    <br/>
  </div>
</div>
